/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
interface coverProps {
    banners?: string[]; // Add this optional prop
  currentBannerIndex?: number;
  bannerImage: any;
}

const CoverImageSettings: React.FC<coverProps> = ({ bannerImage ,banners = [], 
  currentBannerIndex = 0 }) => {
  const navigate = useNavigate();
  const bannerUpdate = () => {
    navigate("/settings/change-banner");
  };
  return (
    <div>
      <div className="cover-photo">
        {bannerImage ? (
          <img
            src={bannerImage}
            alt="Cover Photo"
            width="620px"
            height="210px"
          />
        ) : (
          <img
            src="/assets/images/cover-placeholder.svg"
            alt="Cover Photo"
          />
        )}
        <button className="btn btn-rounded btn-edit" onClick={bannerUpdate}>
          <i className="material-symbols-outlined">edit</i>
          Edit Cover
        </button>
      </div>
    </div>
  );
};

export default CoverImageSettings;